import { useEffect, useRef } from "react";

export function useInfiniteScroll(onLoadMore: () => void, canLoad: boolean) {
  const ref = useRef<HTMLDivElement | null>(null);
  const hasTriggeredRef = useRef(false);

  useEffect(() => {
    if (!canLoad) return;
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          hasTriggeredRef.current = false;
          return;
        }

        if (!hasTriggeredRef.current) {
          hasTriggeredRef.current = true;
          onLoadMore();
        }
      },
      { rootMargin: "600px" }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [onLoadMore, canLoad]);

  return ref;
}
